module.exports = __webpack_public_path__ + "050a13628afd4072e097aa5a13254fc5.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SA.svg
// module id = xKG4
// module chunks = 0